import { HELPSCOUT_ARTICLE_KEYS } from './helpscout-article-keys';

import { isProd } from '../config/config';

class HelpScoutBeacon {
  static identifyUser = (
    email: string,
    normalizedUserAttributes: {
      username: string;
      name: string;
      email: string;
      accountId: string;
      accountName: string;
      accountGroupId: string;
      accountGroupName: string;
      accountStatus: string;
      isTeamEngineAdmin: string;
      isAccountAdmin: string;
      hasMergeIntegration: string;
    },
  ) => {
    const data = {
      ...normalizedUserAttributes,
      email,
      name: normalizedUserAttributes.name.trim(),
      /* Additional properties are used to fill out custom Help Scout customer properties (see: https://developer.helpscout.com/beacon-2/web/javascript-api/#beaconidentify-userobject) */
      'email-targeted': email, // Help Scout (for whatever reason) only allows segmenting outbound chat on custom properties; so we include email as a custom one as well
    };
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.log(`[mock] Beacon Identify: ${JSON.stringify(data)}`);
    } else {
      Beacon('identify', data);
    }
  };

  static openArticle = (articleId: ValueOf<typeof HELPSCOUT_ARTICLE_KEYS>) => {
    Beacon('article', articleId);
  };

  static navigate = (location: string) => {
    Beacon('open');
    Beacon('navigate', location);
  };

  static prefillText = (subject?: string, text?: string) => {
    Beacon('prefill', { subject, text });
  };
}

export const HelpScout = {
  beacon: HelpScoutBeacon,
};
